export default __webpack_public_path__ + "static/media/bull_nft2.2fef716a.png";